
import React from 'react';
import { FoulsSummaryCard } from './FoulsSummaryCard';
import { FoulsLocationCard } from './FoulsLocationCard';
import { calculateFoulsStats, calculateTeamFouls } from '../utils/foulsStats';

interface FoulsStatsSectionProps {
  matches: any[];
}

export const FoulsStatsSection: React.FC<FoulsStatsSectionProps> = ({ matches }) => {
  const overallFoulsStats = calculateFoulsStats(matches);
  const homeFoulsStats = calculateTeamFouls(matches, true);
  const awayFoulsStats = calculateTeamFouls(matches, false);

  // Transform the data to match the expected FoulsSummaryCard props
  const summaryStats = {
    averageFoulsPerGame: overallFoulsStats.average,
    averageHomeFouls: homeFoulsStats.averageFoulsPerGame,
    averageAwayFouls: awayFoulsStats.averageFoulsPerGame,
    overUnderStats: overallFoulsStats.overUnderStats,
    mostFouls: homeFoulsStats.mostFouls,
    leastFouls: homeFoulsStats.leastFouls,
    totalFouls: overallFoulsStats.total
  };

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <FoulsSummaryCard foulsStats={summaryStats} />
        <FoulsLocationCard 
          title="Home Fouls" 
          stats={{
            average: homeFoulsStats.averageFoulsPerGame,
            total: homeFoulsStats.totalFouls,
            mostFouls: {
              team: homeFoulsStats.mostFouls.team,
              value: parseFloat(homeFoulsStats.mostFouls.average)
            },
            leastFouls: {
              team: homeFoulsStats.leastFouls.team,
              value: parseFloat(homeFoulsStats.leastFouls.average)
            },
            overUnderStats: homeFoulsStats.overUnderStats
          }}
        />
        <FoulsLocationCard 
          title="Away Fouls" 
          stats={{
            average: awayFoulsStats.averageFoulsPerGame,
            total: awayFoulsStats.totalFouls,
            mostFouls: {
              team: awayFoulsStats.mostFouls.team,
              value: parseFloat(awayFoulsStats.mostFouls.average)
            },
            leastFouls: {
              team: awayFoulsStats.leastFouls.team,
              value: parseFloat(awayFoulsStats.leastFouls.average)
            },
            overUnderStats: awayFoulsStats.overUnderStats
          }}
        />
      </div>
    </div>
  );
};
